import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { GitService } from '../../api/git.service';
import { gitBranchNameValidator } from '../validators/git-branch-name.validator';

@UntilDestroy()
@Component({
  selector: 'y42-git-branch-filter',
  templateUrl: './git-branch-filter.component.html',
  styleUrls: ['./git-branch-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitBranchFilterComponent implements AfterViewInit {
  constructor(private readonly gitService: GitService) {
    this.gitBranchNameFC.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        tap((value: string) => this.filterUpdate.emit(value)),
        untilDestroyed(this),
      )
      .subscribe();
  }

  @Input() label = 'Search for Branches';

  @Input() set value(val: string) {
    this.gitBranchNameFC.setValue(val);
  }

  @Input() preventFocusOnClear = false;

  @Input() inputAutofocus = false;

  @Output() cleared = new EventEmitter<void>();
  @Output() filterUpdate = new EventEmitter<string>();

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  readonly gitBranchNameFC = new FormControl('', { validators: gitBranchNameValidator, nonNullable: true });

  ngAfterViewInit() {
    if (this.inputAutofocus) {
      setTimeout(() => this.focus(), 100);
    }
  }

  focus() {
    this.searchInput?.nativeElement.focus();
  }

  clear() {
    this.gitBranchNameFC.reset('');
    this.cleared.emit();
  }
}
